/** Leituras do estado da partida usadas pelas telas. */
import { type PublicState, ownedBy, pendingDecision } from '@tigrinho/engine';
import type { GameState } from '@tigrinho/engine';

/** As funções do motor esperam GameState; a visão pública tem tudo que elas leem. */
export const asState = (g: PublicState) => g as unknown as GameState;

export type Decision = ReturnType<typeof pendingDecision>;

export function decision(g: PublicState): Decision {
  return pendingDecision(asState(g));
}

/** De quem é a próxima decisão. */
export function decider(d: Decision): string | null {
  if (d.kind === 'debt' || d.kind === 'turn') return d.player;
  if (d.kind === 'prompt') return d.prompt.player;
  return null;
}

export function myProps(g: PublicState, me: string): number[] {
  return ownedBy(asState(g), me);
}

export function effectsOn(g: PublicState, index: number) {
  const now = g.turnCounter;
  return g.effects.filter((e) => 'square' in e && e.square === index && ('untilTurn' in e ? now < e.untilTurn : true));
}

export function playerEffects(g: PublicState, id: string) {
  const now = g.turnCounter;
  return g.effects.filter((e) => 'player' in e && e.player === id && (!('untilTurn' in e) || now < e.untilTurn));
}

export function globalEffects(g: PublicState) {
  const now = g.turnCounter;
  return g.effects.filter((e) => (e.kind === 'apagao' || e.kind === 'inflacao') && now < e.untilTurn);
}
